import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { PaginatedProgramList } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface IUsePrograms {
  kilo_class_type?: string;
  date?: string;
}

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | null | undefined)[];
}

function usePrograms({
  kilo_class_type,
  date,
}: IUsePrograms): UseInfiniteQueryResult<AxiosResponse<PaginatedProgramList>> {
  const fetchPrograms = ({
    pageParam = { limit: '100', offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedProgramList>> => {
    const params = pageParam;

    if (kilo_class_type) {
      params.kilo_class_type = kilo_class_type;
    }
    if (date) {
      params.date = date;
    }

    return client.get(`programs/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['programs', kilo_class_type, date], fetchPrograms, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: !!kilo_class_type && !!date,
  });
}

export default usePrograms;
